<template>
  <div class="salesmanHelpGiftAddressPage" >
    <div class="pageContent">
      <XR-head titleText="填收货地址" :rightShow="false" ref="headObj"></XR-head>
    
      <mu-row gutter>
        <mu-col width="90" tablet="50" desktop="33">
          <mu-text-field label="收货人" helpText="请输入收货人姓名" icon=":fa fa-user" labelFloat fullWidth v-model="editInfo.Receiver" />
        </mu-col>
      </mu-row>      
      <mu-row gutter>
        <mu-col width="90" tablet="50" desktop="33">
          <mu-text-field label="手机号" helpText="请输入您的手机号" icon=":fa fa-phone" labelFloat fullWidth v-model="editInfo.Phone" />
        </mu-col>
      </mu-row>    
      <mu-row gutter>
        <mu-col width="90" tablet="50" desktop="33">
          <mu-text-field label="省市区" helpText="请选择省市区" icon=":fa fa-map" labelFloat fullWidth v-model="address" @focus="openBottomSheet" />
          <mu-bottom-sheet :open="bottomSheet" @close="closeBottomSheet">            
            <mu-picker :slots="addressSlots" :visible-item-count="5" @change="addressChange" :values="address" @itemClick="closeBottomSheet"/>
          </mu-bottom-sheet>
        </mu-col>
      </mu-row>      
      <mu-row gutter>
        <mu-col width="90" tablet="50" desktop="33">
          <mu-text-field label="邮编" type="number" helpText="请输6位数邮编" icon=":fa fa-truck" labelFloat fullWidth v-model="editInfo.PosCode" :maxLength="6" />
        </mu-col>
      </mu-row>    
      <mu-row gutter>
        <mu-col width="90" tablet="50" desktop="33">
          <mu-text-field label="详细地址" multiLine :rows="2" :rowsMax="5" :maxLength="50" helpText="请输入您的详细地址" icon=":fa fa-map-marker" labelFloat fullWidth v-model="editInfo.Address" />
        </mu-col>
      </mu-row>   
      <mu-row gutter>
        <mu-col width="90" tablet="50" desktop="33">
          <mu-text-field label="选择送货时间" helpText="请选择您的收货时间" icon=":fa fa-time" labelFloat fullWidth v-model="shippingDateName" @focus="open('delivery')"/>
        </mu-col>
      </mu-row> 

      <mu-popup position="bottom" popupClass="salesmanHelpGiftAddressPage-popupLayer delivery" :open="deliveryPopup" @close="close('delivery')">
        <mu-sub-header>请选择送货时间</mu-sub-header>
        <div class="deliveryChoose">
          <template v-for="dateItem in shippingDateList">
            <mu-raised-button :label="dateItem.method" :class="shippingDateId==dateItem.Id?'shippingBtn select':''" @click="selectShippingDate(dateItem.Id,dateItem.method)" :key="dateItem.Id"></mu-raised-button>
          </template>
        </div>
        <mu-raised-button primary @click="choseDelivery()" fullWidth class="delvieryChooseBtn" label="确定"/>
      </mu-popup>

      <div class="bottom-bar">
        <mu-row >
          <mu-col width="100" tablet="100" desktop="100">
            <mu-raised-button label="确 定" class="gobuy" primary fullWidth @click="submit"></mu-raised-button>
          </mu-col>
        </mu-row>
      </div>
    </div>
    <XR-toast @onClose="submitSuccess" ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
import cart from '../../util/cart'

var address = {
  '北京': {'北京':['北京']},
  '湖北': {'武汉':['武昌区','汉阳区','青山区'], '黄石':['黄石']},
  '台湾': {'台北市':['台北市']}
}
export default {
  data () {
    return {
      deliveryPopup: false,
      shippingDateList:[],
      
      bottomSheet: false,
      selectAddress:'',      
      addressSlots: [
        {
          width: '100%',
          textAlign: 'right',
          values: ['北京']
        }, {
          width: '100%',
          textAlign: 'center',
          values: ['北京市']
        }, {
          width: '100%',
          textAlign: 'left',
          values: ['东城区']
        }
      ],
      shippingDateId:0,
      shippingDateName:'',
      address: ['请选择', '请选择','请选择'],
      addressProvince: '北京',
      addressCity: '北京市',
      addressArea: '东城区',
      editInfo:{
        UserNameList:[],
        shippingDateId:0,
        Receiver:'',
        Phone:'',
        Address:'',
        Province : '',
        City:'',
        Area:'',
        PosCode:''
      }
    }
  },
  mounted:function(){
    this.$refs.XRtoast.load()
    this.getShippingDateList()
    this.getAreaList()
  },
  methods: {
    open (obj) {
      this[obj+'Popup'] = true
    },
    close (obj) {
      this[obj+'Popup'] = false
    },
    closeChoose(obj){
      this[obj+'Popup'] = false
    },    
    getShippingDateList(){    
      var ths = this  
      ths.$post(
        "/Salesman/RetailServer/GetShippingDateList"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.shippingDateList = res.Data
          ths.$refs.XRtoast.hide()
          ths.loaded = false
        }
      });
    },
    selectShippingDate(id,name ){
      this.shippingDateId = id
      this.shippingDateName = name
    },
    choseDelivery(){
      this.editInfo.shippingDateId = this.shippingDateId
      this.close('delivery')
    },
    submit(){
      var userNameList = this.$route.query.userNameList
      if(!userNameList){        
        this.$refs.XRtoast.failed("请选择要补货的会员", true)
        return
      }
      if(this.editInfo.shippingDateId==0){
        this.$refs.XRtoast.failed("请选择配送时间", true)
        return
      }

      this.editInfo.UserNameList= userNameList.split(',')

      var ths = this
      ths.$post(
        "/Salesman/SalesmanServer/HelpUnGetGift",
        JSON.stringify(this.editInfo)
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{      
          ths.$refs.XRtoast.success(res.Msg, true)
        }
      });
    },
    submitSuccess(){
      this.$router.push('/salesman/mymemberviplist')
    },
    
    getAreaList(){
      var ths = this;   
      ths.$post(
        "/Salesman/BaseServer/GetAreaAllListGroup"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{     
          address= JSON.parse(res.Data) 
          ths.addressSlots[0].values = Object.keys(address)   
          
          if(ths.$route.query.id){ 
            ths.getInfo()
          }else{
            ths.loaded = false
            ths.$refs.XRtoast.hide()
          }    
        }
      });
    },
    addressChange (value, index) {
      switch (index) {
        case 0:
          this.addressProvince = value
          var cirtyList = address[value]
          var keys = Object.keys(cirtyList)          
          this.addressSlots[1].values = keys
          this.addressCity = keys[0]
          
          var areaList = address[this.addressProvince][this.addressCity]        
          this.addressSlots[2].values = areaList
          this.addressArea = areaList[0]
          break
        case 1:      
          this.addressCity = value
          var arr1 = address[this.addressProvince][value]          
          this.addressSlots[2].values = arr1
          this.addressArea = arr1[0]
          break
        case 2:
          this.addressArea = value
          break
      }
      this.address = [this.addressProvince, this.addressCity, this.addressArea]
      this.editInfo.Province = this.addressProvince
      this.editInfo.City = this.addressCity
      this.editInfo.Area = this.addressArea
    },
    closeBottomSheet () {
      this.bottomSheet = false
    },
    openBottomSheet () {
      this.bottomSheet = true
    },
  }
}
</script>
<style>
body .salesmanHelpGiftAddressPage{
  background:white;
}
.pageContent{
  padding-bottom: 56px;
}

.salesmanHelpGiftAddressPage .goIcon{
  width: 20px;
  float: right;
  text-align: right;
}

.salesmanHelpGiftAddressPage .mapIcon{
  float: left;
  width: 30px;
  line-height: 64px;
}

.salesmanHelpGiftAddressPage .receive-address{
  background: white;
  color:black;
  padding: 10px;
  overflow: hidden;
}
.salesmanHelpGiftAddressPage .receive-address .address-info{
  float: left;
}
.salesmanHelpGiftAddressPage .receive-address .address-info .name{
  font-size:16px;
  font-weight: 700;
  padding-right: 15px;
}
.salesmanHelpGiftAddressPage .receive-address .address-info .mobile{
  font-size:16px;
  font-weight: 700;
}
.salesmanHelpGiftAddressPage .receive-address .address-info .address-content{
  font-size:12px;
  line-height: 18px;
  color:#999;
}
.salesmanHelpGiftAddressPage .receive-address .address-info .address-content .fa{
  width: 20px;
}
.salesmanHelpGiftAddressPage .receive-address .goIcon{
  line-height: 64px;
}

.salesmanHelpGiftAddressPage .choose-info{
  overflow: hidden;
  padding:10px;
  background: white;
  margin-top: 10px;
}
.salesmanHelpGiftAddressPage .choose-info .info{
  font-size: 12px;
  float: left;
  line-height: 24px;
}
.salesmanHelpGiftAddressPage .choose-info .info.center{
  float: right;
}
.salesmanHelpGiftAddressPage .choose-info .info.left {
  width: 150px;
}
.salesmanHelpGiftAddressPage .choose-info .info.left .title{
  font-size: 14px;
  font-weight: 700;
}
.salesmanHelpGiftAddressPage .choose-info .info .choose-row{
  line-height: 24px;
}
.salesmanHelpGiftAddressPage .choose-info .info.center .choose-row{
  text-align: right;
}
.salesmanHelpGiftAddressPage .choose-info.integral .info.left .choose-row.balance{
  color:red;
}
.salesmanHelpGiftAddressPage .choose-info .goIcon{
  line-height: 48px;
}

.salesmanHelpGiftAddressPage .remark{
  background: white;
  margin-top: 10px;
  padding:10px 10px 0;
}

.salesmanHelpGiftAddressPage .price-info{
  background: white;
  margin-top: 10px;
  padding:10px 10px 40px;
}
.salesmanHelpGiftAddressPage .price-info .row{
  background: white;
  overflow: hidden;
  line-height: 32px;
}
.salesmanHelpGiftAddressPage .price-info .row .title{
  font-size: 14px;
  font-weight: 700;
}
.salesmanHelpGiftAddressPage .price-info .row .price{
  color:Red;
  font-weight: 700;
}



.salesmanHelpGiftAddressPage .pro-list{
  margin-top: 10px;
  background: white;
  overflow: hidden;
}
.salesmanHelpGiftAddressPage .pro-list .pro-item{
  padding: 16px 0;
  overflow: hidden;
}
.salesmanHelpGiftAddressPage .pro-list .pro-item .pro-img{
  width: 80px;
  float: left;
}
.salesmanHelpGiftAddressPage .pro-list .pro-item .pro-img img{
  width: 100%;
  display: block;
  border-radius: 4px;
  margin: 0 20px;
}
.salesmanHelpGiftAddressPage .pro-list .pro-item .pro-info{
  float: right;
  padding-right: 10px;
}
.salesmanHelpGiftAddressPage .pro-list .pro-item .pro-info .pro-name{
  font-size: 12px;
  line-height: 16px;
  height: 32px;
  padding-bottom: 4px;
  overflow: hidden;
}
.salesmanHelpGiftAddressPage .pro-list .pro-item .pro-info .pro-attr{
  font-size: 12px;
  line-height: 16px;
  height: 30px;
  color:#999;
}
.salesmanHelpGiftAddressPage .pro-list .pro-item .pro-info .pro-num{
  font-size: 12px;
  line-height: 16px;
  height: 16px;
  color:#999;
}
.salesmanHelpGiftAddressPage .pro-list .pro-item .pro-info .pro-num .pro-price{
  font-size: 16px;
  line-height: 16px;
  float: left;
  color:red;
}
.salesmanHelpGiftAddressPage .pro-list .pro-item .pro-info .pro-num .count{
  font-size: 12px;
  line-height: 16px;
  color:#999;
  float: right;
}




.salesmanHelpGiftAddressPage .bottom-bar{  
  margin-top: 50px;
  height: 56px;
  padding: 0 10%;
}
.salesmanHelpGiftAddressPage .gobuy{
  width: 100%;
  line-height: 50px;
  height: 50px;
  text-align: center;
}

.salesmanHelpGiftAddressPage-popupLayer {
  width: 100%;
  min-height: 120px;
}
.salesmanHelpGiftAddressPage-popupLayer .deliveryChoose {
  padding: 0 10px;
}
.salesmanHelpGiftAddressPage-popupLayer .delvieryChooseBtn{
  margin: 40px 0 0;
  height: 50px; 
}

.salesmanHelpGiftAddressPage-popupLayer .shippingBtn.select{
  background: red;
  color:white;
}

</style>



// WEBPACK FOOTER //
// src/pages/salesman/salesmanHelpGiftAddress.vue